/**
 * Текущее время, обновляемое с заданным шагом: относительные подписи («14 секунд назад») не
 * застывают на экране, пока данные не перезапрашиваются.
 */
import { useEffect, useState } from 'react';

export function useNow(intervalMs: number): number {
	const [now, setNow] = useState(() => Date.now());
	useEffect(() => {
		const timer = setInterval(() => setNow(Date.now()), intervalMs);
		return () => clearInterval(timer);
	}, [intervalMs]);
	return now;
}
